<script>
  import useHidePrices, { DEFAULT_HIDDEN_PRICE_SYMBOL } from '~/composables/useHidePrices'

  const defaultAlternative = (h) => {
    return h('span', {
      domProps: {
        innerHTML: DEFAULT_HIDDEN_PRICE_SYMBOL,
      },
    })
  }

  export default {
    functional: true,
    render(h, context) {
      const { isHiddenPrices } = useHidePrices()

      if (isHiddenPrices.value) {
        return context.slots().alternative || defaultAlternative(h)
      }
      return context.slots().default
    },
  }
</script>
